import { getIcd } from '../api-config';

const icdService = '/icd';

export const getIcdPathologies = async (data: any, params: any, language: any) =>
  await getIcd(icdService, '/icd/release/11/2023-01/mms/search', data, params, language);
